import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-titulo-h2',
  templateUrl: './titulo-h2.component.html',
  styleUrls: ['./titulo-h2.component.scss']
})
export class TituloH2Component {
  @Input("titulo") titulo: string;
}
